"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .directive("freitagExportConfig", () => ({
    restrict: "E",
    templateUrl: "app/admin/company/dataexport/freitag-export/freitag-config.html",
    controller: "FreitagExportConfigCtrl",

    scope: {
      form: "=",
      originalForm: "=",
      selectedItem: "=",
    },
  }))
